import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class PaymentGeteways extends Component {
  state = {
    user_id: localStorage.getItem("user_id"),
    user_role: localStorage.getItem("user_role"),

    cash_on_delivery_status: 0,
    provider_name: "",
    payment_type: "",
    account_number: "",
    payment_instruction: "",

    loading: false,
  };

  // -----------------------------
  // Handle Inputs
  // -----------------------------
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleCheckbox = (e) => {
    this.setState({ cash_on_delivery_status: e.target.checked ? 1 : 0 });
  };

  // -----------------------------
  // Fetch Data (GET)
  // -----------------------------
  fetchExistingSettings = async () => {
    const { user_id, user_role } = this.state;

    if (!user_id || !user_role) return;

    try {
      this.setState({ loading: true });

      const res = await axios.get("/get_payment_geteway", {
        params: { user_id, user_role },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.data) {
        const d = res.data.data;

        this.setState({
          cash_on_delivery_status: d.cash_on_delivery_status == 1 ? 1 : 0,
          provider_name: d.provider_name || "",
          payment_type: d.payment_type || "",
          account_number: d.account_number || "",
          payment_instruction: d.payment_instruction || "",
        });
      }
    } catch (error) {
      console.log("No existing data found");
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.fetchExistingSettings();
  }

  // -----------------------------
  // Save or Update (POST)
  // -----------------------------
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      user_id,
      user_role,
      cash_on_delivery_status,
      provider_name,
      payment_type,
      account_number,
      payment_instruction,
    } = this.state;

    if (!user_id || !user_role) {
      Swal.fire("Error", "User ID or User Role missing", "error");
      return;
    }

    try {
      this.setState({ loading: true });

      const res = await axios.post(
        "/payment_geteways",
        {
          user_id,
          user_role,
          cash_on_delivery_status,
          provider_name,
          payment_type,
          account_number,
          payment_instruction,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      Swal.fire("Success", res.data.message, "success");
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  // -----------------------------
  // Render UI
  // -----------------------------
  render() {
    const {
      cash_on_delivery_status,
      provider_name,
      payment_type,
      account_number,
      payment_instruction,
      loading,
    } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4">
                  <form onSubmit={this.handleSubmit}>
                    <h4 className="fw-semibold text-uppercase text-center mb-3">
                      Payment Gateways
                    </h4>
                    <p className="fw-semibold text-center mb-3">
                      Add Cash on Delivery OR Mobile Banking Gateway
                    </p>

                    <div className="row g-3">

                      {/* Cash On Delivery */}
                      <div className="col-12 text-center">
                        <div className="form-check d-flex justify-content-center">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="codCheck"
                            checked={cash_on_delivery_status === 1}
                            onChange={this.handleCheckbox}
                          />
                          <label className="form-check-label ms-2" htmlFor="codCheck">
                            Cash on Delivery
                          </label>
                        </div>
                      </div>

                      {/* Provider Fields only if CASH ON DELIVERY OFF */}
                      {cash_on_delivery_status === 0 && (
                        <>
                          {/* Provider */}
                          <div className="col-md-12">
                            <label className="form-label">
                              Select Provider <span className="text-danger">*</span>
                            </label>
                            <select
                              name="provider_name"
                              className="form-control"
                              value={provider_name}
                              onChange={this.handleChange}
                              required
                            >
                              <option value="">Select Provider</option>
                              <option value="Bkash">Bkash</option>
                              <option value="Nagad">Nagad</option>
                              <option value="Rocket">Rocket</option>
                            </select>
                          </div>

                          {/* Payment Type */}
                          <div className="col-md-12">
                            <label className="form-label">
                              Payment Type <span className="text-danger">*</span>
                            </label>
                            <select
                              name="payment_type"
                              className="form-control"
                              value={payment_type}
                              onChange={this.handleChange}
                              required
                            >
                              <option value="">Select Type</option>
                              <option value="Sent Money (Manual)">
                                Sent Money (Manual)
                              </option>
                              <option value="Payment (Manual)">
                                Payment (Manual)
                              </option>
                            </select>
                          </div>

                          {/* Account Number */}
                          {payment_type && (
                            <>
                              <div className="col-md-12">
                                <label className="form-label">Account Number</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="account_number"
                                  value={account_number}
                                  onChange={this.handleChange}
                                  placeholder="Enter Account Number"
                                  required
                                />
                              </div>

                              {/* Payment Instruction */}
                              <div className="col-md-12">
                                <label className="form-label">Payment Instruction</label>
                                <textarea
                                  className="form-control"
                                  rows={3}
                                  name="payment_instruction"
                                  value={payment_instruction}
                                  onChange={this.handleChange}
                                  placeholder="Enter instructions..."
                                ></textarea>
                              </div>
                            </>
                          )}
                        </>
                      )}

                    </div>

                    {/* Submit */}
                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentGeteways;
